<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      :action="uploadURL"
      :limit="limit"
      name="file"
      :file-list="fileList"
      :show-file-list="true"
      :on-remove="onRemove"
      :on-success="handlePictureCardPreview"
      accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
    >
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: ['fileList', 'index', 'limit'],
  data() {
    return {
      fileImgList: []
    };
  },
  methods: {
    onRemove(file, fileList) {
      this.fileImgList = this.getList(fileList);
      this.$emit('change', this.fileImgList, this.index);
    },
    handlePictureCardPreview(response, file, fileList) {
      this.fileImgList = this.getList(fileList);
      this.$emit('change', this.fileImgList, this.index);
    },
    getList(fileList) {
      return fileList.map(el => {
        return {
          name: el.name,
          url: el.size ? this.imgUrl + el.response.data.store_result : el.url,
          uid: el.uid
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
